export const minkMinkMinkLyrics = [
  { text: "Caller number three", start: 10.5, end: 12.47 },
  { text: "What do you have", start: 12.47, end: 14.46 },
  { text: "Yeah this message is for Tony", start: 14.46, end: 16.50 },
  { text: "Share your story", start: 16.50, end: 18 },
  { text: "Okay", start: 18, end: 18.9 },
  { text: "We might have a solution", start: 18.9, end: 20.54 },
  { text: "Can't complain", start: 20.54, end: 23.6 },
  { text: "When you do it", start: 23.6, end: 26.75 },
  { text: "You make a bitch go bad", start: 26.75, end: 30.56 },
  { text: "When you do it", start: 30.56, end: 32.74 },
  { text: "Out the way", start: 32.74, end: 35.147 },
  { text: "I ain't movin", start: 35.147, end: 38.413 },
  { text: "When you come headed my way", start: 38.413, end: 41.95 },
  { text: "I ain't losing", start: 41.95, end: 44.03 },
  { text: "Hmm", start: 44.03, end: 46 },
  { text: "Don't nobody love you like I do", start: 46, end: 50.43 },
  { text: "Like I can", start: 50.43, end: 52.5 },
  { text: "Ooooo", start: 52.5, end: 57.46 },
  { text: "Don't you wanna know what it feels like", start: 57.46, end: 62 },
  { text: "To feel like a man", start: 62, end: 69 },
  { text: "Niggas like you aren't a dime a dozen", start: 69, end: 72 },
  { text: "For you I be knuckin and buckin", start: 72, end: 75 },
  { text: "Babe", start: 75, end: 77.46 },
  { text: "Babe", start: 77.46, end: 80 },
  { text: "I'm pullin tracks", start: 80, end: 82 },
  { text: "Down to the very last", start: 82, end: 85.39 },
  { text: "And once you're in my grasp", start: 85.39, end: 88.16 },
  { text: "They'll be no runnin baby", start: 88.16, end: 92.2 },
  { text: "Look here", start: 92.2, end: 92.9 },
  { text: "Woo", start: 92.9, end: 93.5 },
  { text: "Hoo", start: 93.5, end: 94.3 },
  { text: "Hoo", start: 94.3, end: 95 },
  { text: "Don't be shy", start: 95, end: 97.5 },
  { text: "Call me baby", start: 97.5, end: 100.5 },
  { text: "Woo", start: 100.5, end: 101 },
  { text: "Hoo", start: 101, end: 101.5 },
  { text: "Hoo", start: 101.5, end: 102 },
  { text: "Call me", start: 102, end: 102.5 },
  { text: "Hoo", start: 102.5, end: 103 },
  { text: "Hoo", start: 103, end: 103.5 },
  { text: "Takin you for granted is a trap", start: 103.5, end: 105 },
  { text: "It's a trap babe", start: 105, end: 106 },
  { text: "Why would I ever do that", start: 106, end: 108.22 },
  { text: "Know that you're still healing from your past", start: 108.22, end: 111.74 },
  { text: "That makes two but I'll be damned if", start: 111.74, end: 114.5 },
  { text: "Huh", start: 114.5, end: 115 },
  { text: "Heard them bitches tryin to get atcha", start: 115, end: 117.5 },
  { text: "Get atcha", start: 117.5, end: 118.5 },
  { text: "Fuck around and try me if you won't to I'm waitin", start: 118.5, end: 121.5 },
  { text: "Till the bitter end", start: 121.5, end: 123.7 },
  { text: "And he can't have", start: 123.7, end: 125 },
  { text: "He can't have no friends", start: 125, end: 126.7 },
  { text: "Plenty niggas in this section but don't get it confused", start: 126.7, end: 132.3 },
  { text: "When the DJ plays this record know who I'm runnin to", start: 132.3, end: 137.77 },
  { text: "Plenty niggas in this section but don't get it confused", start: 137.77, end: 143.7 },
  { text: "When the DJ plays this record boy I'm runnin to you", start: 143.7, end: 149.38 },
  { text: "Oooo", start: 149.5, end: 151 },
  { text: "Aye uh uh", start: 151, end: 155 },
  { text: "Caller number three", start: 155, end: 156.59 },
  { text: "Come get Cho girl man", start: 156.59, end: 158.55 },
  { text: "Oooooo", start: 158.55, end: 160 },
  { text: "Ooooo", start: 160, end: 161.7 },
  { text: "Niggas like you aren't a dime a dozen", start: 161.7, end: 165 },
  { text: "For you I be knuckin and buckin", start: 165, end: 167.8 },
  { text: "Babe", start: 167.8, end: 169.97 },
  { text: "Babe", start: 169.97, end: 172.74 },
  { text: "I'm pullin tracks", start: 172.74, end: 174.7 },
  { text: "Down to the very last", start: 174.7, end: 178 },
  { text: "And once you're in my grasp", start: 178, end: 180 },
  { text: "They'll be no runnin baby", start: 180, end: 184.6 },
  { text: "Won't you let me keep you company", start: 184.6, end: 187 },
  { text: "Won't you let me keep you company", start: 187, end: 189.75 },
  { text: "I'll give ya all you need", start: 189.75, end: 191 },
  { text: "Won't you let me keep you company", start: 191, end: 193 },
  { text: "Won't you let me won't you", start: 193, end: 195.4 },
  { text: "Won't you let me le let me le let me let me", start: 195.4, end: 196.8 },
  { text: "Ooo", start: 196.8, end: 197 },
  { text: "Won't you let me keep you company", start: 197, end: 200 },
  { text: "Won't you let me keep you company baby", start: 200, end: 202.6 },
  { text: "I want you", start: 202.6, end: 203 },
  { text: "Won't you let me keep you company", start: 203, end: 205 },
  { text: "Let me let me let me let me let me let me", start: 205, end: 208 },
  { text: "Ooo", start: 208, end: 210 },
  { text: "Call me", start: 210, end: 212.29 },
  { text: "C- c- c- call me", start: 212.29, end: 214 },
  { text: "Don't be shy", start: 214, end: 215.51 },
  { text: "C- c- c- c- c- c- call me", start: 215.51, end: 219.9 },
  { text: "Call me", start: 219.9, end: 221.7 },
] as const satisfies ReadonlyArray<{ readonly text: string, readonly start?: number, readonly end?: number }>;
